import { commonConstants } from '../_constants';
import { initialState } from '../_helpers';

export function desAirports(state=initialState.desAirports, action) {
    switch (action.type) {
        case commonConstants.DES_AIRPORTS_SUCCESS:
            return Object.assign({}, state, action.desAirports);
        case commonConstants.CREATE_AIRPORT_SUCCESS:
            return Object.assign({}, state, false);
        default:
          return state
      }
}


// WEBPACK FOOTER //
// ./src/_reducers/desAirport.reducer.js